<template>
  <div>
    <b-alert
      class="position-fixed fixed-top m-0 rounded-0 text-center"
      fade
      :show="dismissCountDown"
      :variant="errorMessage.color"
      @dismissed="dismissed"
      >{{ errorMessage.text }}</b-alert
    >
    <div class="teste d-none d-sm-block">
      <div class="teste2">
        <img
          src="@/assets/project_create_illo_welcome@2x.png"
          class="teste3"
          fluid
        />
      </div>
    </div>
    <header class="bg-light">
      <div class="container py-4">
        <h1 class>Crédito Imobiliário CAIXA</h1>
        <h6 class="lead">Crie sua proposta de forma rápida e descomplicada.</h6>
      </div>
    </header>
    <div class="container py-3">
      <div
        class="row"
        v-for="(v, index) in $v.userForm.$each.$iter"
        :key="index"
      >
        <div class="col-md-4 col-sm-12" v-if="index == userForm.length - 1">
          <input
            :value="user.email"
            type="text"
            class="form-control form-control-sm money"
            name="userEmail"
            id="userEmail"
            style="display: none"
          />
          <div>
            <blockquote class="blockquote" id="subTitle">
              <p class="mb-0">{{ headerHeading[currentIndex] }}</p>
              <footer class="blockquote-footer">
                É o que tem maior renda!
                <i
                  class="fas fa-question-circle"
                  style="color: orange"
                  data-toggle="popover"
                  title="Proponente Principal"
                  data-content="Se a proposta possui mais de um participante ao crédito, indique o que possui maior renda."
                ></i>
              </footer>
            </blockquote>
          </div>
        </div>
        <div class="col-md-5 col-sm-12" v-if="index == userForm.length - 1">
          <div class="form-group">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="CPF*"
              name="cpf"
              @blur="duplicityCpfCheck"
              v-mask="['###.###.###-##']"
              :class="{
                'is-invalid': $v.userForm.$each[currentIndex].cpf.$error,
              }"
              v-model.trim="$v.userForm.$each[currentIndex].cpf.$model"
              @input="$v.userForm.$each[currentIndex].cpf.$touch()"
            />
            <small
              class="text-danger"
              v-if="
                !$v.userForm.$each[currentIndex].cpf.required &&
                $v.userForm.$each[currentIndex].cpf.$error
              "
            >
              <em>Campo obrigatório</em>
            </small>
            <small
              class="text-danger"
              v-if="!$v.userForm.$each[currentIndex].cpf.minLength"
            >
              <em>Insira o nº de CPF completo</em>
            </small>
          </div>

          <div class="form-group">
            <input
              type="text"
              class="form-control form-control-sm text-capitalize"
              placeholder="Nome Completo*"
              name="name"
              :class="{
                'is-invalid': $v.userForm.$each[currentIndex].fullName.$error,
              }"
              v-model.lazy="$v.userForm.$each[currentIndex].fullName.$model"
              @input="forceUpper($event)"
            />
            <small
              class="text-danger"
              v-if="
                !$v.userForm.$each[currentIndex].fullName.required &&
                $v.userForm.$each[currentIndex].fullName.$error
              "
            >
              <em>Campo obrigatório</em>
            </small>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control form-control-sm pis"
              placeholder="PIS"
              name="pis"
              id="pis"
              v-mask="['###.#####.##-#']"
              v-model.lazy="$v.userForm.$each[currentIndex].pis.$model"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Profissão"
              name="profession"
              id="profession"
              :class="{
                'is-invalid': $v.userForm.$each[currentIndex].occupation.$error,
              }"
              v-model.lazy="$v.userForm.$each[currentIndex].occupation.$model"
            />
            <small
              class="text-danger"
              v-if="
                !$v.userForm.$each[currentIndex].occupation.required &&
                $v.userForm.$each[currentIndex].occupation.$error
              "
            >
              <em>Campo obrigatório</em>
            </small>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control form-control-sm phone_with_ddd"
              placeholder="Telefone*"
              name="telephone"
              id="telephone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :class="{
                'is-invalid':
                  $v.userForm.$each[currentIndex].phoneNumber.$error,
              }"
              v-model.lazy="$v.userForm.$each[currentIndex].phoneNumber.$model"
            />
            <small
              class="text-danger"
              v-if="
                !$v.userForm.$each[currentIndex].phoneNumber.required &&
                $v.userForm.$each[currentIndex].phoneNumber.$error
              "
            >
              <em>Campo obrigatório</em>
            </small>
            <small
              class="text-danger"
              v-if="!$v.userForm.$each[currentIndex].phoneNumber.minLength"
            >
              <em>Informe um telefone válido</em>
            </small>
          </div>
          <div
            class="form-group"
            v-if="
              currentIndex > 0
                ? userForm[currentIndex - 1].maritalStatusField !== 'Casado'
                  ? true
                  : false
                : true
            "
          >
            <select
              class="custom-select custom-select-sm"
              id="maritalStatus"
              name="maritalStatusField"
              :class="{ 'is-invalid': requiredMarit }"
              v-model.trim="userForm[currentIndex].maritalStatusField"
              @change="getChange()"
            >
              <option :value="null">Informe o estado civil*</option>
              <option value="Solteiro">Solteiro</option>
              <option value="Casado" id="maritalStatusMarried">Casado</option>
              <option value="Divorciado/Separado">Divorciado/Separado</option>
              <option value="Viúvo">Viúvo</option>
            </select>
            <small class="text-danger" v-if="requiredMarit">
              <em>Campo obrigatório</em>
            </small>
          </div>
          <!-- <div
            class="form-group"
            v-if="currentIndex > 0 ?  userForm[currentIndex - 1].maritalStatusField !== 'Casado' ? true : false : true"
          >
            <select
              class="custom-select custom-select-sm"
              id="maritalStatus"
              name="maritalStatusField"
              :class="{ 'is-invalid': $v.userForm.$each[currentIndex].maritalStatusField.$error}"
              v-model.trim="$v.userForm.$each[currentIndex].maritalStatusField.$model"
              @change="getChange()"
            >
              <option :value="null">Informe o estado civil*</option>
              <option value="Solteiro">Solteiro</option>
              <option value="Casado" id="maritalStatusMarried">Casado</option>
              <option value="Divorciado/Separado">Divorciado/Separado</option>
              <option value="Viúvo">Viúvo</option>
            </select>
            <small
              class="text-danger"
              v-if="!$v.userForm.$each[currentIndex].maritalStatusField.isUnique
                && $v.userForm.$each[currentIndex].maritalStatusField.$anyDirty"
            >
              <em>Campo obrigatório</em>
            </small>
          </div> -->
          <currency-input
            class="form-control form-control-sm mb-4"
            maxlength="15"
            :class="{
              'is-invalid': $v.userForm.$each[currentIndex].salaryAmount.$error,
            }"
            placeholder="Valor do salário"
            v-model.lazy="$v.userForm.$each[currentIndex].salaryAmount.$model"
            currency="BRL"
            locale="pt"
            :distraction-free="false"
            :auto-decimal-mode="true"
          />
          <div class="form-group">
            <input
              type="email"
              class="form-control form-control-sm text-lowercase"
              placeholder="E-mail*"
              name="email"
              id="email"
              :class="{
                'is-invalid': $v.userForm.$each[currentIndex].email.$error,
              }"
              v-model.lazy="$v.userForm.$each[currentIndex].email.$model"
            />

            <span class="d-flex justify-content-end my-1">
              <a
                class="text-primary"
                style="cursor: pointer"
                @click="undeclaredEmail"
                ><small
                  ><em>Clique aqui se não sabe ou não tem e-mail!</em></small
                ></a
              >
            </span>

            <small
              class="text-danger"
              v-if="
                !$v.userForm.$each[currentIndex].email.required &&
                $v.userForm.$each[currentIndex].email.$error
              "
            >
              <em>Campo obrigatório</em>
            </small>
            <small
              class="text-danger"
              v-if="!$v.userForm.$each[currentIndex].email.email"
            >
              <em>Insira um e-mail válido.</em>
            </small>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                type="checkbox"
                id="fgtsCheck"
                name="fgtsCheck"
                v-model.lazy="userForm[index].fgtsCheck"
              />
              <label class="custom-control-label" for="fgtsCheck"
                >Desejo utilizar os recursos do meu FGTS.</label
              >
            </div>
          </div>
        </div>
      </div>
      <b-row>
        <div class="col-md-4 col-sm-12"></div>
        <div class="col-md-5 col-sm-12">
          <Navigation
            :stepOneValidations="validFirstStep"
            :goNext="goNext"
            :isInvalid="$v.userForm.$invalid"
            ref="navigate"
          ></Navigation>

          <div class="d-flex" v-if="userForm.length > 1 && currentIndex >= 0">
            <button
              class="btn btn-light"
              @click="currentIndex = currentIndex - 1"
            >
              <i
                class="fas fa-chevron-left"
                data-toggle="popover"
                title="Ver anterior"
              />
            </button>
            <button
              class="btn btn-light ml-2"
              @click="currentIndex = currentIndex + 1"
              v-if="currentIndex < userForm.length - 1"
            >
              <i
                class="fas fa-chevron-right"
                data-toggle="popover"
                title="Próximo"
              />
            </button>
          </div>
        </div>
      </b-row>
    </div>

    <!-- Stable Union Modal -->
    <b-modal v-model="showStableUnionPopup" centered :hide-header="true">
      <div class="text-center">Cliente possui ou mantém união estável?</div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right w-25 ml-3"
            @click="yesStable"
            >Yes</b-button
          >
          <b-button
            variant="light"
            size="sm"
            class="float-right w-25"
            @click="noStable"
            >No</b-button
          >
        </div>
      </template>
    </b-modal>

    <!-- Add Participant Modal -->
    <b-modal v-model="addParticipantPopup" centered :hide-header="true">
      <div class="text-center">Deseja adicionar outro participante?</div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right w-25 ml-3"
            @click="addParticipantYes"
            >Yes</b-button
          >
          <b-button
            variant="light"
            size="sm"
            class="float-right w-25"
            @click="addParticipantNo"
            >No</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Navigation from "./Navigation";
import { mask } from "vue-the-mask";
import { required, minLength, email } from "vuelidate/lib/validators";
import { cpf } from "cpf-cnpj-validator";
import db from "../../main";
import { CurrencyInput } from "vue-currency-input";

var bootbox = require("bootbox");

export default {
  data() {
    return {
      showStableUnionPopup: false,
      addParticipantPopup: false,
      userForm: [
        {
          cpf: "",
          fullName: "",
          pis: "",
          occupation: "",
          phoneNumber: "",
          maritalStatusField: null,
          salaryAmount: null,
          email: "",
          fgtsCheck: false,
          stableUnionWith: {},
          marriedWith: {},
        },
      ],
      headerHeading: ["Diga-nos sobre o proponente principal ao crédito."],
      currentIndex: 0,
      goNext: false,
      stableUnionArray: [],
      requiredMarit: false,
    };
  },
  validations() {
    if (
      this.currentIndex > 0 &&
      this.userForm[this.currentIndex - 1].maritalStatusField == "Casado"
    ) {
      return {
        userForm: {
          required,
          minLength: minLength(1),
          $each: {
            cpf: { required, minLength: minLength(14) },
            fullName: { required },
            pis: {},
            occupation: {},
            phoneNumber: { required, minLength: minLength(14) },
            email: { required, email },
            salaryAmount: { required },
            stableUnionWith: {},
            marriedWith: {},
          },
        },
      };
    } else {
      return {
        userForm: {
          required,
          minLength: minLength(1),
          $each: {
            cpf: { required, minLength: minLength(14) },
            fullName: { required },
            pis: {},
            occupation: {},
            phoneNumber: { required, minLength: minLength(14) },
            // maritalStatusField: {
            //   isUnique(value) {
            //     console.log(value, 'kokokoko', this.currentIndex)
            //     if (this.userForm.length == 2) {
            //       console.log('hiiiii', this.userForm[1].maritalStatusField);
            //     }
            //     if (this.currentIndex == 0 && value == null) {
            //       return false;
            //     }
            //     if (this.currentIndex >= 2 && value != null && this.userForm[this.currentIndex - 2].maritalStatusField == 'Casado') {
            //       return true;
            //     }
            //     if (this.currentIndex == 0 && value != null) {
            //       return true;
            //     } else {
            //       console.log(this.userForm[this.currentIndex - 1].maritalStatusField, value , 'hhhhhh');
            //       if (
            //         this.userForm[this.currentIndex - 1].maritalStatusField == "Casado" && value == null
            //       ) {
            //         console.log('koi bhi string');
            //         return true;
            //       } else {
            //         console.log('else koi bhi string', value);
            //         if (value != null) return true;
            //         else {
            //           console.log('else y chla')
            //         return false;
            //         }
            //       }
            //     }

            //   },
            // },
            email: { required, email },
            salaryAmount: { required },
          },
        },
      };
    }
  },
  components: {
    Navigation,
    CurrencyInput,
  },
  mounted() {
    if (this.participantsArray.length) this.userForm = this.participantsArray;
    let prevroute = JSON.parse(localStorage.getItem("previousRoute"));
    if (
      prevroute != "/documentations" ||
      prevroute != "/proposalInformations"
    ) {
      this.$store.commit("setBlankProposal");
    }
  },
  computed: {
    ...mapState([
      "user",
      "proposal",
      "errorMessage",
      "dismissCountDown",
      "participantsArray",
    ]),
  },
  mutations: {
    ...mapMutations(["setErrorMessage", "setBlankProposal"]),
  },
  methods: {
    ...mapMutations(["setUserProposals", "setParticipantArray"]),
    ...mapActions(["createProposal", "dismissed"]),
    async duplicityCpfCheck(e) {
      //if(this.$v.userForm.$each[this.currentIndex].cpf.$model == '000.000.000-00'){
      //  alert('asdasd')
      //}

      try {
        const snapshotProposal = await db
          .collection("proposals")
          .where(
            "cpf",
            "==",
            this.$v.userForm.$each[this.currentIndex].cpf.$model
          )
          .where("steps.contract.situation", "==", "")
          .limit(1)
          .get();

        if (!snapshotProposal.empty) {
          bootbox.alert({
            title: "Ops... : )",
            message:
              "Localizamos uma proposta existente para esse CPF. Entre em contato com o seu consultor para dar continuidade. ; )",
            centerVertical: true,
            locale: "pt",
            buttons: {
              ok: {
                label: "Entendi!",
              },
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async validFirstStep() {
      this.$v.$touch();
      if (
        this.currentIndex > 0 &&
        this.userForm[this.currentIndex - 1].maritalStatusField == "Casado" &&
        this.userForm[this.currentIndex].maritalStatusField != null
      ) {
        if (
          this.userForm[this.userForm.length - 1].maritalStatusField !==
          "Casado"
        ) {
          if (this.userForm.length == 1) this.showStableUnionPopup = true;
          if (
            this.userForm.length > 1 &&
            this.stableUnionArray[this.userForm.length - 2] == "participant"
          ) {
            this.showStableUnionPopup = true;
          } else if (
            this.userForm.length > 1 &&
            this.stableUnionArray[this.userForm.length - 2] != "participant"
          ) {
            this.addParticipantPopup = true;
          }
        } else {
          this.headerHeading.push("Informe os dados do(a) cônjuge.");
          this.stableUnionArray.push("married");
          this.addBlankUser();
        }
      } else if (
        (this.currentIndex == 0 && !this.userForm[0].maritalStatusField) ||
        // (this.currentIndex > 0 &&
        //   this.userForm[this.currentIndex - 1].maritalStatusField != "Casado" &&
        //   this.currentIndex > 1 &&
        //   this.userForm[this.currentIndex - 2].maritalStatusField ==
        //     "Casado") ||
        (this.currentIndex > 0 &&
          this.userForm[this.currentIndex - 1].maritalStatusField != "Casado" &&
          this.userForm[this.currentIndex].maritalStatusField == null) ||
        (this.currentIndex > 0 &&
          !this.userForm[this.currentIndex - 1].maritalStatusField &&
          !this.userForm[this.currentIndex].maritalStatusField)
      ) {
        this.requiredMarit = true;
        this.$store.commit("setErrorMessage", {
          color: "danger",
          text: "Ops... Corrija os dados necessários para prosseguir.2222",
        });
      } else if (this.$v.$invalid) {
        this.$store.commit("setErrorMessage", {
          color: "danger",
          text: "Ops... Corrija os dados necessários para prosseguir.3333",
        });
      } else if (
        cpf.isValid(this.$v.userForm.$each[this.currentIndex].cpf.$model) ===
        false
      ) {
        this.$store.commit("setErrorMessage", {
          color: "danger",
          text: "Ops...Invalid CPF",
        });
      } else {
        if (
          this.userForm[this.userForm.length - 1].maritalStatusField !==
          "Casado"
        ) {
          if (this.userForm.length == 1) {
            this.showStableUnionPopup = true;
          }
          if (
            this.userForm.length > 1 &&
            this.stableUnionArray[this.userForm.length - 2] == "participant"
          ) {
            this.showStableUnionPopup = true;
          } else if (
            this.userForm.length > 1 &&
            this.stableUnionArray[this.userForm.length - 2] != "participant"
          ) {
            this.addParticipantPopup = true;
          }
        } else {
          this.headerHeading.push("Informe os dados do(a) cônjuge.");
          this.stableUnionArray.push("married");
          await this.addBlankUser();
          this.userForm[this.currentIndex].marriedWith = {
            name: this.userForm[this.currentIndex - 1].fullName,
            cpf: this.userForm[this.currentIndex - 1].cpf,
          };
        }
        // do your submit logic here
        // this.submitStatus = 'PENDING'
        // setTimeout(() => {
        // this.submitStatus = 'OK'
        // }, 500)
      }
    },
    async validateUserArray() {
      this.$v.$touch();
      if (this.$v.userForm.$invalid) {
        this.$store.commit("setErrorMessage", {
          color: "danger",
          text: "Ops... Corrija os dados necessários para prosseguir.",
        });
      } else {
        await this.setUserProposals(this.userForm);
        this.goNext = true;
        this.setParticipantArray(this.userForm);
        this.$router.push("/proposalInformations");
      }
    },
    noStable() {
      this.showStableUnionPopup = false;
      this.addParticipantPopup = true;
    },
    async yesStable() {
      this.showStableUnionPopup = false;
      this.stableUnionArray.push("stable");
      this.headerHeading.push("Informe os dados do(a) companheiro(a).");
      await this.addBlankUser();
      this.userForm[this.currentIndex].stableUnionWith = {
        name: this.userForm[this.currentIndex - 1].fullName,
        cpf: this.userForm[this.currentIndex - 1].cpf,
      };
    },
    addParticipantYes() {
      this.addParticipantPopup = false;
      this.headerHeading.push("Informe os dados do(a) nova participante.");
      this.stableUnionArray.push("participant");
      this.addBlankUser();
    },
    addParticipantNo() {
      this.addParticipantPopup = false;
      this.validateUserArray();
    },
    addBlankUser() {
      this.$v.$touch();
      if (this.$v.userForm.$invalid) {
        this.$store.commit("setErrorMessage", {
          color: "danger",
          text: "Ops... Corrija os dados necessários para prosseguir.33333",
        });
      } else {
        this.requiredMarit = false;
        this.currentIndex = this.currentIndex + 1;
        this.userForm.push({
          cpf: "",
          fullName: "",
          pis: "",
          occupation: "",
          phoneNumber: "",
          maritalStatusField: null,
          salaryAmount: null,
          email: "",
          fgtsCheck: false,
          stableUnionWith: {},
          marriedWith: {},
        });
      }
    },
    getChange() {
      if (this.userForm.length - 1 > this.currentIndex) {
        if (
          (this.stableUnionArray[this.currentIndex] == "married" &&
            this.userForm[this.currentIndex].maritalStatusField != "Casado") ||
          (this.stableUnionArray[this.currentIndex] != "married" &&
            this.userForm[this.currentIndex].maritalStatusField == "Casado")
        ) {
          this.userForm = this.userForm.splice(0, this.currentIndex + 1);
        }
      }
    },
    undeclaredEmail() {
      this.userForm[this.currentIndex].email = "naodeclarado@cliente.com";
    },
    /* It includes this method to save the name in the DB as capitalized | Inclui esse método para que salve no DB o nome já como maiúsculo*/
    forceUpper (e) {
      e.target.value = e.target.value.toUpperCase()
    }
  },
  directives: {
    mask,
  },
};
</script>
<style scoped>
.teste {
  background-attachment: scroll;
  background-color: #039be5;
  /* background-image: url(images/grain@2x.png); */
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 100% 100%;
  flex: 0 0 320px;
  height: 100%;
  /*min-height: 851px;*/
  position: absolute;
  position: fixed;
  right: 0;
  top: 0;
  width: 320px;
  z-index: 0;
}

.teste2 {
  /* height: 718px;*/
  pointer-events: none;
  position: absolute;
  position: fixed;
  right: 0px;
  /* top: 133px; */
  bottom: 0;
  width: 568px;
}

.teste3 {
  height: 80vh;
  position: absolute;
  width: 568px;
  bottom: 0;
  right: 10px;
  z-index: inherit;
}
</style>
